import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { Link } from '@bd/bdcore-named-routes';

const styles = css`
  position: absolute;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  padding: 60px 20px 20px 20px;
  overflow-y: scroll;
  z-index: 100;
  background-color: #111111;
  @media (min-width: 992px) {
    top: 68px;
    left: 0;
    width: 100vw;
    height: auto;
    padding: 0;
    background-color: transparent;
  }
  .ToggleMenu_menu {
    list-style: none;
    padding: 0 0 15px 0;
    margin: 0;
    padding: 0;
  }
  .ToggleMenu_menuItem {
    list-style: none;
    padding: 15px 0 15px 0;
    border-bottom: 1px solid #333333;
    a {
      color: #FFFFFF;
      font-size: 16px;
      font-weight: 700;
    }

  }
  .ToggleMenu_menuClose {
    display: block;
    position: absolute;
    right: 40px;
    top: 40px;
    width: 20px;
    height: 20px;
    background-image: url('/images/icon-close-white.svg');
    background-repeat: no-repeat;
    background-color: transparent;
    border: 0;
    @media (min-width: 992px) {
      display: none;
    }
  }
`;

function ToggleMenu({ isActive, toggleMenu }) {
  return (
    <div className={styles} style={{ display: isActive ? 'block' : 'none' }}>
      <button className="ToggleMenu_menuClose" onClick={toggleMenu} />
      <ul className="ToggleMenu_menu">
        <li className="ToggleMenu_menuItem"><Link name="communities">Our Communities</Link></li>
        <li className="ToggleMenu_menuItem"><Link name="homes">Our Homes</Link></li>
        <li className="ToggleMenu_menuItem"><Link name="photo-gallery">Photo Gallery</Link></li>
        <li className="ToggleMenu_menuItem"><Link name="about-us">About Us</Link></li>
        <li className="ToggleMenu_menuItem"><Link name="contact-us">Contact Us</Link></li>
      </ul>
    </div>
  );
}

ToggleMenu.propTypes = {
  isActive: PropTypes.bool.isRequired,
  toggleMenu: PropTypes.func.isRequired,
};

export default withData({
  communities: true,
})(ToggleMenu);



// WEBPACK FOOTER //
// ./src/components/ToggleMenu.js